import { ErpWorkflowTestformComponent } from './component/erpworkflowtestform.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // for using ngModel directive
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { PanelModule } from 'primeng/panel';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';

import { HisSharedModule } from 'hisng';
import { ErpWorkflowOperationComponent } from './component/erpworkflowoperation.component';
import { ErpWorkflowHistoryComponent } from './component/erpworkflowhistory.component';
import { ErpWorkflowHistoryTestComponent } from './component/erpworkflowhistorytest.component';

/**
 * SharedModule for ERP workflow.
 */
@NgModule( {
    imports: [
        // Angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        DragDropModule,

        // PrimeNG
        AutoCompleteModule,
        PanelModule,
        AccordionModule,
        TableModule,

        // HIS
        HisSharedModule
    ],

    declarations: [
        ErpWorkflowOperationComponent,
        ErpWorkflowTestformComponent,
        ErpWorkflowHistoryComponent,
        ErpWorkflowHistoryTestComponent
    ],

    exports: [
        ErpWorkflowOperationComponent,
        ErpWorkflowTestformComponent,
        ErpWorkflowHistoryComponent,
        ErpWorkflowHistoryTestComponent
    ]

    // NO PROVIDERS! Providers need to go into ErpWorkflowCoreModule
} )
export class ErpWorkflowSharedModule {
}
